import { useState, useEffect } from 'react';
import { revenueApi } from '../services/revenue.api';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { currency, fmtDate } from '../lib/formatters';
import { AlertCircle } from 'lucide-react';

export default function Revenue() {
  const [forecast, setForecast] = useState([]);
  const [outstanding, setOutstanding] = useState([]);

  useEffect(() => {
    revenueApi.forecast().then(r => setForecast(r.data));
    revenueApi.outstanding().then(r => setOutstanding(r.data));
  }, []);

  const today = new Date().toISOString().split('T')[0];

  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-zinc-900">Revenue</h1>

      {/* Forecast chart */}
      <div className="bg-white border border-zinc-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-zinc-700 mb-4">6-Month Forecast</h2>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={forecast} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={v => `₹${(v/1000).toFixed(0)}k`} />
            <Tooltip formatter={(val) => currency(val)} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="expected" fill="#818cf8" name="Expected" radius={[3,3,0,0]} />
            <Bar dataKey="received" fill="#34d399" name="Received" radius={[3,3,0,0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Outstanding invoices */}
      <div className="bg-white border border-zinc-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-zinc-700 mb-3">Outstanding Invoices ({outstanding.length})</h2>
        {outstanding.length === 0 ? (
          <p className="text-sm text-zinc-400">No outstanding invoices.</p>
        ) : (
          <div className="divide-y divide-zinc-100">
            {outstanding.map(l => (
              <div key={l.id} className="py-2.5 flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-zinc-800">{l.company_name}</p>
                  <p className="text-xs text-zinc-400">{l.contact_name}</p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-zinc-900">{currency(l.invoice_amount)}</p>
                  <p className={`text-xs ${l.invoice_due_date < today ? 'text-red-500' : 'text-zinc-400'}`}>
                    {l.invoice_due_date < today && <AlertCircle size={10} className="inline mr-0.5" />}
                    Due {fmtDate(l.invoice_due_date)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
